import React, { Component } from 'react';
import { connect } from 'react-redux';
import { content } from '../../infrastructure/content/selectors';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import SignatoriesAndShareholdersPage from '../signatoriesAndShareholdersSection/SignatoriesAndShareholdersPage';
import {
  generateApplicant,
  getControlBusinessValues
} from '../../infrastructure/officer/payloadUtils/mapOfiicerDetails';
import { getShareHolderPercentage } from '../personDetailsSection/utils/personaDetailsUtils';

class ShareHolder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditbuttonClicked: false
    };
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.onPrimaryApplicantSubmit = this.onPrimaryApplicantSubmit.bind(this);
  }

  onEditButtonClick() {
    this.setState({ isEditbuttonClicked: !this.state.isEditbuttonClicked });
  }

  onPrimaryApplicantSubmit(values) {
    this.props.saveSignatoriesAndShareholdersForm(
      values,
      generateApplicant(values, this.props.primaryApplicant)
    );
    this.onEditButtonClick();
  }

  render() {
    const {
      shareHolderInfo,
      brandId,
      bankId,
      signatoriesAndShareholder,
      isSoleTrader,
      primaryApplicant,
      externalContent
    } = this.props;
    const { authorizedSignitory, percentagePerOwnCompany, underPercentage } = externalContent;
    const getShareHolderList = () => {
      let shareHolderlist = [
        {
          key: authorizedSignitory,
          value: shareHolderInfo.authorisedSignatory
        }
      ];
      if (!isSoleTrader) {
        shareHolderlist = [
          ...shareHolderlist,
          {
            key: percentagePerOwnCompany,
            value: getShareHolderPercentage(
              shareHolderInfo.significantShareHolder,
              shareHolderInfo.percentageOfCompanyShares,
              underPercentage
            )
          }
        ];
      }
      return shareHolderlist;
    };
    const { isEditbuttonClicked } = this.state;
    return (
      <div>
        <SectionHeading>{shareHolderInfo.name}</SectionHeading>
        {!isEditbuttonClicked && <GenericDescriptionList items={getShareHolderList()} />}

        {this.state.isEditbuttonClicked && (
          <div>
            {getSignatoriesAndShareHolderForm(
              brandId,
              bankId,
              this.onPrimaryApplicantSubmit,
              signatoriesAndShareholder,
              primaryApplicant
            )}
          </div>
        )}
        {!isSoleTrader && (
          <Inline.LeftAligned
            nodes={[
              <NavigationButton.Tertiary
                labelText={isEditbuttonClicked ? 'Cancel Editing' : 'Edit'}
                onClick={() => {
                  this.onEditButtonClick();
                }}
              />
            ]}
          />
        )}
      </div>
    );
  }
}
const getSignatoriesAndShareHolderForm = (
  brandId,
  bankId,
  onPrimaryApplicantSubmit,
  getBusinessData,
  primaryApplicant
) => (
  <SignatoriesAndShareholdersPage
    brandId={brandId}
    bankId={bankId}
    saveSignatoriesAndShareholdersForm={onPrimaryApplicantSubmit}
    getBusinessData={getControlBusinessValues(getBusinessData, primaryApplicant)}
  />
);
const mapStateToProps = state => ({
  externalContent: content(state)
});

export default connect(mapStateToProps, null)(ShareHolder);
